export class AppSettings {
  // Project API
  public static API_GET_ALL_PROJECT = '/projects';
};
